module.exports = __webpack_public_path__ + "img/Apus.c4ca69cc.png";